import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class UpdateContentService {

    public abstract getOrAddUpdateStream<T>(key: string, updateOperation: () => Promise<T>, maxConsecutiveFailures?: number, updateCooldownInMs?: number, updateTimeoutInMs?: number, bypassInitialCooldown?: boolean): Observable<T>;

    public abstract pushUpdate(key: string): Promise<void>;
}
